import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared';
// import { PriceBookEventContainerModel } from '../../../../../../models/aggregates/erp/price-book/price-book-event-container.model';
import { FinancialItemEventContainerModel } from '../../../../../../models/aggregates/erp/financial/financial-item-event-container.model';

@Injectable({providedIn: 'root'})
export class FinancialItemEventService extends BaseApiTemplateService<FinancialItemEventContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/events';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/events';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/fi-items/events';
    this.httpClient = http;
  }
}
